import NotFoundTemplate from 'features/errors/templates/NotFoundTemplate/NotFoundTemplate';

export default function NotFoundPage() {
  return (
    <NotFoundTemplate />
  );
}
